var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.748,
    height: 48.748,
    viewBox: "0 0 48.748 48.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.679,23.358A11.679,11.679,0,1,1,23.358,11.679,11.694,11.694,0,0,1,11.679,23.358Zm0-20.312a8.632,8.632,0,1,0,8.632,8.632A8.651,8.651,0,0,0,11.679,3.047Z",
    transform: "translate(12.695 2.539)",
    fill: "#ef7a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M36.419,17.265A1.534,1.534,0,0,1,34.9,15.741c0-7.007-7.15-12.695-15.924-12.695S3.047,8.734,3.047,15.741a1.534,1.534,0,0,1-1.523,1.523A1.534,1.534,0,0,1,0,15.741C0,7.068,8.511,0,18.971,0S37.942,7.068,37.942,15.741A1.534,1.534,0,0,1,36.419,17.265Z",
    transform: "translate(5.403 28.944)",
    fill: "#ef7a30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H48.748V48.748H0Z",
    fill: "none",
    opacity: 0
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e167b7daf57beb0c465f75551d69c054.svg";
export { ForwardRef as ReactComponent };